<template>
  <el-form :model="form" label-width="120px" @submit.prevent="submitForm">
    <el-form-item label="Title">
      <el-input v-model="form.title" required></el-input>
    </el-form-item>

    <el-form-item label="Content">
      <rich-text-editor v-model="form.content"></rich-text-editor>
    </el-form-item>

    <el-collapse>
      <el-collapse-item title="SEO Options">
        <el-form-item label="SEO Title">
          <el-input v-model="form.seo_title"></el-input>
        </el-form-item>

        <el-form-item label="Meta Description">
          <el-input type="textarea" v-model="form.meta_description"></el-input>
        </el-form-item>
      </el-collapse-item>
    </el-collapse>

    <el-form-item label="Image">
      <el-upload
        class="upload-demo"
        :action="uploadUrl"
        :on-success="handleImageUpload"
        :file-list="fileList"
        :headers="{'X-CSRF-TOKEN': csrfToken}"
      >
        <el-button size="small" type="primary">Click to upload</el-button>
      </el-upload>
    </el-form-item>

    <el-form-item label="Status">
      <el-select v-model="form.status">
        <el-option label="Draft" value="draft"></el-option>
        <el-option label="Published" value="published"></el-option>
        <el-option label="Archived" value="archived"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item label="Publication Date" v-if="form.status === 'published'">
      <el-date-picker
        v-model="form.published_at"
        type="datetime"
        placeholder="Select date and time"
      >
      </el-date-picker>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" native-type="submit">Submit</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import RichTextEditor from './RichTextEditor.vue'
import axios from 'axios'

export default {
  components: {
    RichTextEditor,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
    submitUrl: {
      type: String,
      required: true
    },
    uploadUrl: {
      type: String,
      required: true
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        title: '',
        content: '',
        seo_title: '',
        meta_description: '',
        status: 'draft',
        image_path: '',
        published_at: null,
      },
      fileList: [],
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  created() {
    Object.assign(this.form, this.initialData)
    if (this.initialData.image_path) {
      this.fileList = [{ name: 'Current Image', url: this.initialData.image_path }]
    }
  },
  methods: {
    async submitForm() {
      try {
        let response;
        if (this.isEdit) {
          response = await axios.put(this.submitUrl, this.form)
        } else {
          response = await axios.post(this.submitUrl, this.form)
        }
        console.log('Form submitted successfully:', response.data)
        this.$emit('form-submitted', response.data)
        window.location.href = '/posts'
      } catch (error) {
        console.error('Error submitting form:', error)
        this.$emit('form-error', error)
        this.$message.error('An error occurred while submitting the form. Please try again.')
      }
    },
    handleImageUpload(response, file, fileList) {
      this.form.image_path = response.url
    },
  },
}
</script>